import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { RiFileExcel2Line } from "react-icons/ri";
import { TbCopy } from "react-icons/tb";
import Pagination from "react-js-pagination";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import {
  Badge,
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
  Table,
  Tooltip,
} from "reactstrap";
import swal from "sweetalert";
import {
  applyClassToCharacters,
  BASEURL,
  convertUTCToLocalTime,
  getStringFromJSX,
  isUrdu,
  LoadingSpinner,
} from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { GetLanguageString, NoResult } from "../../helper/Components";
import {
  DateValidater,
  GetCustomStyles,
  GetFooTableCustomStyles,
  GetSelectedLanguage,
} from "../../helper/Method";
import { ApiNotifications } from "../ApiNotifications";
import CancelRequestModal from "../CancelRequestModal";
import EditAddNewRafiqNotificationModal from "../EditAddNewRafiqNotificationModal";
// import EditMoveMemberNotificationModal from "../EditMoveMemberNotificationModal";
import { addMember } from "../../member/ApiMember";
import PrintMarkRafiqExNotification from "../../member/MemberMarkEx/PrintMarkRafiqExNotification";
import { ApiMemberTypeRequest } from "../../member/MemberType/ApiMemberTypeRequest";
import { viewReceiptPdf, viewExpenseVoucherPdf } from "../../shared/receiptViewer";
import { ApiMonthlyReports } from "../../unit/MonthlyReports/ApiMonthlyReports";
import FundsInfaqAmanatViewForm from "../FundsInfaqAmanatViewForm";
import FundsOtherIncomeNotificationDetails from "../FundsOtherIncomeNotificationDetails";
import SalaryTransferNotificationDetails from "../salaryTransfer/SalaryTransferNotificationDetails";
import PrintAssignResponsibilityNotification from "../PrintAssignResponsibilityNotification";
import PrintNotification from "../PrintNotification";
import SeeChanges from "../SeeChanges";
import TransactionTransferNotificationModal from "../TransactionTransferNotificationModal";
import UsraRemittanceApprovalForm from "../UsraRemittanceApprovalForm";

const MemberRequests = ({ history }) => {
  const notify = (string) => toast.success(string);
  const { t } = useTranslation();
  const [pagination, setPagination] = useState({ activePage: 1 });
  const memberId = encryptStorage.getItem("memberId");
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [viewFinanceNotificationModel, setViewFinanceNotificationModel] =
    useState(false);
  const [viewInfaqAmanatForm, setViewInfaqAmanatForm] = useState(false);
  const [
    viewOtherIncomeNotificationDetails,
    setViewOtherIncomeNotificationDetails,
  ] = useState(false);
  const [viewSalaryTransferDetails, setViewSalaryTransferDetails] =
    useState(false);
  const [viewUsraRemittanceApprovalForm, setViewUsraRemittanceApprovalForm] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [excelButtonDisable, setExcelButtonDisable] = useState(false);
  const [modal, setModal] = useState(false);
  const [values, setValues] = useState(false);
  const [cancelRequestModal, setCancelRequestModal] = useState(false);
  const [updateList, setupdateList] = useState(false);
  const [notification, setNotification] = useState([]);
  const [notificationName, setNotificationName] = useState();
  const [notificationId, setNotificationId] = useState();
  const [serialNumber, setSerialNumber] = useState();
  const [searchName, setSearchName] = useState("");
  // const [moveMemberModal, setMoveMemberModal] = useState(false);
  const [addRafiqModal, setAddRafiqModal] = useState(false);
  // const [moveMemberMemberId, setMoveMemberMemberId] = useState();
  // const [moveMemberUnitId, setMoveMemberUniId] = useState();
  // const [moveMemberPermission, setMoveMemberPermission] = useState("");
  const [relevantUnitsList, setRelevantUnitsList] = useState([]);
  const [selectedRelevantUnit, setSelectedRelevantUnit] = useState();
  const [searchSerialNumber, setSearchSerialNumber] = useState();
  const [isSerialNumberCancelled, setIsSerialNumberCancelled] = useState();
  const [printType, setPrintType] = useState(0);
  const [responsibilityData, setResponsibilityData] = useState("");
  const [notificationTypes, setNotificationTypeFilter] = useState([]);
  const [selectedType, setSelectedType] = useState({ value: 0, label: "All" });

  const [approvalStatuses, setApprovalStatusesFilter] = useState([]);
  const [selectedApprovalStatus, setSelectedApprovalStatus] = useState({
    value: -1,
    label: "All",
  });

  const [responsibilities, setResponsibilitiesFilter] = useState([]);
  const [selectedResponsibility, setSelectedResponsibility] = useState({
    value: 0,
    label: "تمام",
  });

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const dateRangeValidation = {
    startDate: null,
    endDate: null,
  };
  const [dateValidations, setDateValidations] = useState(dateRangeValidation);

  const [documents, setDocuments] = useState();
  const unit = {
    unitId: loggedInUnitId,
    unitName: "",
  };

  const [tooltipOpen, setTooltipOpen] = useState(null);
  const [tooltipOpenCopy, setTooltipOpenCopy] = useState(null);

  const toggleTooltipCopy = (index) => {
    setTooltipOpenCopy((prevOpen) => (prevOpen === index ? null : index));
  };

  const [record, setRecord] = useState({
    memberId: memberId,
    notificationTypeId: selectedType.value,
    approvalStatus: selectedApprovalStatus.value,
    relevantUnit: selectedRelevantUnit?.value,
    serialNumber: searchSerialNumber,
    startDate: startDate ?? Date.minDate,
    endDate: endDate,
    responsibilityId: selectedResponsibility.value,
    activePage: 1,
    creationDate: "neutral",
    fullName: searchName,
  });

  const [printData, setPrintData] = useState({
    contactNo: "",
    email: "",
    dob: "",
    education: "",
    fatherName: "",
    fullName: "",
    infradiDawat: "",
    jihadBilMaal: "",
    maritalStatus: "",
    mubtadiCourse: {
      startDate: "",
      location: "",
    },
    multazimCourse: {
      startDate: "",
      location: "",
    },
    nisabBaraEMutaliya: "",
    occupation: "",
    newAddress: "",
    registranNumber: "",
    responsibilityName: "",
    samaOBasar: "",
    samaOTaat: "",
    taluqMaAllah: "",
    ameerName: "",
    unitName: "",
    otherInfo: "",
  });

  const handlePageChange = (pageNumber) => {
    setRecord({
      ...record,
      memberId: memberId,
      notificationTypeId: selectedType.value,
      approvalStatus: selectedApprovalStatus.value,
      relevantUnit: selectedRelevantUnit?.value,
      serialNumber: searchSerialNumber,
      startDate: startDate ?? Date.minDate,
      endDate: endDate,
      responsibilityId: selectedResponsibility.value,
      activePage: pageNumber,
      fullName: searchName,
    });
    setPagination({
      ...pagination,
      activePage: pageNumber,
    });
  };

  const openFile = (id, serial) => {
    addMember()
      .GetMemberMarkAsExRequestFile(id, serial)
      .then((res) => {
        const binaryData = atob(res.data.bytes);
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uintArray = new Uint8Array(arrayBuffer);

        for (let i = 0; i < binaryData.length; i++) {
          uintArray[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uintArray], { type: res.data.fileType });
        const url = URL.createObjectURL(blob);

        const newTab = window.open();
        newTab.document.open();
        newTab.document.write(`
          <html>
          <head>
            <style>
              body {
                margin: 0;
                overflow: hidden;
              }
              iframe {
                width: 100%;
                height: 100%;
                border: none;
                background-color: transparent;
              }
            </style>
          </head>
          <body>
            <iframe src="${url}"></iframe>
          </body>
        </html>
      `);
        newTab.document.close();

        URL.revokeObjectURL(url);
      })
      .catch((err) => {
        swal({
          title: "Error: " + err.response?.data || err,
          icon: "error",
          buttons: "OK",
        });
        console.log(err.response.data);
      });
  };

  const downloadNotificationExcel = (id, type) => {
    return new Promise((resolve, reject) => {
      const toastId = toast.loading(
        t("notification_monthly_report_downloading_excel"),
      );
      ApiMonthlyReports()
        .GetMonthlyReportExcel(id)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(
            blob,
            type.includes("usra")
              ? "UsraMonthlyReportExcel.xlsx"
              : "MuqamiTanzeemMonthlyReportExcel.xlsx",
          );
          toast.update(toastId, {
            render: getStringFromJSX(
              applyClassToCharacters(
                getStringFromJSX(
                  <GetLanguageString
                    props={"notification_monthly_report_downloaded_excel"}
                  />,
                ),
                "ur",
              ),
            ),
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
          resolve(true); // Resolve promise on success
        })
        .catch(async (err) => {
          let message = "Something went wrong.";

          try {
            if (err.response) {
              // Try to decode ArrayBuffer to string if it's binary
              const data = err.response.data;

              if (data instanceof ArrayBuffer) {
                const textDecoder = new TextDecoder();
                const decoded = textDecoder.decode(data);

                // decoded may contain your actual error message string
                message = decoded || err.message;
              } else if (typeof data === "string") {
                message = data;
              } else {
                message = data?.message || JSON.stringify(data) || err.message;
              }

              // Specific error message check
              if (message.includes("Report doesn't exist")) {
                message = "This report doesn't exist or has been deleted.";
              }
            } else {
              message = err.message || "Unknown error occurred.";
            }
          } catch (decodeErr) {
            console.error("Error decoding response:", decodeErr);
          }

          toast.update(toastId, {
            render: `Failed to download: ${message}`,
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });

          reject(err);
          console.error("Download Error:", err);
        });
    });
  };
  const downloadMonthlyReportPdf = async (id) => {
    const toastId = toast.loading(t("downloading_pdf"));

    try {
      const res = await ApiMonthlyReports().GetMonthlyReportPdf(id);
      const fileUrl = BASEURL + res.data.url;

      if (!fileUrl) throw new Error("Report URL not found.");

      // Attempt to open download in a new tab (popup)
      const newWindow = window.open(fileUrl, "_blank");

      if (
        !newWindow ||
        newWindow.closed ||
        typeof newWindow.closed === "undefined"
      ) {
        // ❌ Popup blocked
        toast.update(toastId, {
          render:
            "Popup was blocked. Please allow popups for this site to download the file.",
          type: "warning",
          isLoading: false,
          autoClose: 8000,
        });
        return;
      }

      // ✅ Popup allowed — start download
      newWindow.focus();

      toast.update(toastId, {
        render: t("downloaded_pdf"),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (err) {
      console.error("Download error:", err);
      const message =
        err?.response?.data?.message || err.message || "Something went wrong.";

      toast.update(toastId, {
        render: t("error_downloading_file", { message }),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  const downloadWelcomeLetter = (memberId, memberName) => {
    return new Promise((resolve, reject) => {
      const toastId = toast.loading(
        t("member_add_rafiq_request_downloading_welcome_letter"),
      );

      addMember()
        .GetMemberWelcomeLetter({ memberId: memberId })
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/pdf" });
          saveAs(blob, `WelcomeLetter_${memberName}.pdf`);

          toast.update(toastId, {
            render: getStringFromJSX(
              applyClassToCharacters(
                getStringFromJSX(
                  <GetLanguageString
                    props={"member_add_rafiq_request_downloaded_welcome_letter"}
                    value={memberName}
                  />,
                ),
                "ur",
              ),
            ),
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
          resolve(true); // Resolve promise on success
        })
        .catch((err) => {
          console.error(`Error generating PDF: ${err}`);
          toast.update(toastId, {
            render: `Failed to download: ${err.message}`,
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
          reject(err); // Reject promise on error
        });
    });
  };

  const downloadNotificationPdf = (
    memberId,
    memberName,
    notificationType,
    id,
  ) => {
    return new Promise((resolve, reject) => {
      const toastId = toast.loading(
        t("member_member_type_request_downloading_form"),
      );

      // Determine the API call and filename based on notification type
      let apiCall, fileName;
      if (notificationType.includes("multazim")) {
        apiCall = ApiMemberTypeRequest().DeclareMubtadiToMultazimForm;
        fileName = `MubtadiToMultazimForm - ${memberName}.pdf`;
      } else if (notificationType.includes("tawajah")) {
        apiCall = ApiMemberTypeRequest().DeclareMemberAsTawajahTalabForm;
        fileName = `TawajahTalabForm - ${memberName}.pdf`;
      } else if (notificationType.includes("muatazir")) {
        apiCall = ApiMemberTypeRequest().DeclareMemberToMutazirForm;
        fileName = `MuatazirForm - ${memberName}.pdf`;
      } else {
        const err = new Error("Invalid notification type");
        toast.update(toastId, {
          render: `Failed to download: ${err.message}`,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
        return reject(err);
      }

      // Common success handler
      const handleSuccess = (res) => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        saveAs(blob, fileName);

        toast.update(toastId, {
          render: getStringFromJSX(
            applyClassToCharacters(
              getStringFromJSX(
                <GetLanguageString
                  props={"member_member_type_request_downloading_form"}
                />,
              ),
              "ur",
            ),
          ),
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
        resolve(true);
      };

      // Common error handler
      const handleError = (err) => {
        console.error(`Error generating PDF: ${err}`);
        toast.update(toastId, {
          render: `Failed to download: ${err.message}`,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
        reject(err);
      };

      // Make the API call
      apiCall({ memberId, notificationId: id })
        .then(handleSuccess)
        .catch(handleError);
    });
  };

  const downloadFile = (id, serial) => {
    addMember()
      .GetMemberMarkAsExRequestFile(id, serial)
      .then((res) => {
        const binaryData = atob(res.data.bytes);
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uintArray = new Uint8Array(arrayBuffer);

        for (let i = 0; i < binaryData.length; i++) {
          uintArray[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uintArray], { type: res.data.fileType });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = res.data.fileName;
        link.click();

        URL.revokeObjectURL(url);

        URL.revokeObjectURL(url);
      })
      .catch((err) => {
        swal({
          title: "Error: " + err.response?.data || err,
          icon: "error",
          buttons: "OK",
        });
        console.log(err.response.data);
      });
  };

  const handleSorting = () => {
    if (
      record.creationDate === "neutral" ||
      record.creationDate === "descending"
    ) {
      setRecord({
        ...record,
        creationDate: "ascending",
      });
    } else if (record.creationDate === "ascending") {
      setRecord({
        ...record,
        creationDate: "descending",
      });
    }
  };

  const toggleTooltip = (index) => {
    setTooltipOpen((prevOpen) => (prevOpen === index ? null : index));
  };

  const moment = require("moment");

  useEffect(() => {
    setLoading(true);
    ApiNotifications()
      .GetNotificationTypes("requests")
      .then((res) => {
        setNotificationTypeFilter(res.data);
      })
      .catch((err) => {
        swal({
          title: "Error: " + err.response?.data || err,
          icon: "error",
          buttons: "OK",
        });
        console.log(err.response.data);
        setLoading(false);
      });

    ApiNotifications()
      .GetApprovalStatuses("requests")
      .then((res) => {
        setApprovalStatusesFilter(res.data);
      })
      .catch((err) => {
        swal({
          title: "Error: " + err.response?.data || err,
          icon: "error",
          buttons: "OK",
        });
        console.log(err.response.data);
        setLoading(false);
      });

    ApiNotifications()
      .GetMemberRequestsRelevantUnits("requests")
      .then((res) => {
        setRelevantUnitsList(res.data);
        setSelectedRelevantUnit(res.data[0]);
      })
      .catch((err) => {
        swal({
          title: "Error: " + err.response?.data || err,
          icon: "error",
          buttons: "OK",
        });
        console.log(err.response.data);
        setLoading(false);
      });

    ApiNotifications()
      .GetResponsibilitiesForNotifications(memberId, "requests")
      .then((res) => {
        setResponsibilitiesFilter(res.data);
      })
      .catch((err) => {
        swal({
          title: "Error: " + err.response?.data || err,
          icon: "error",
          buttons: "OK",
        });
        console.log(err.response.data);
        setLoading(false);
      });
  }, [memberId]);

  useEffect(() => {
    setLoading(true);
    ApiNotifications()
      .getMemberRequests(record)
      .then((res) => {
        setPagination(res.data);
        setNotification(res.data.notificationList);
        setLoading(false);
      })
      .catch((err) => {
        swal({
          title: "Error: " + err.response?.data || err,
          icon: "error",
          buttons: "OK",
        });
        console.log(err.response.data);
        setLoading(false);
      });
  }, [record, memberId, updateList]);

  const copyToClipboard = (link) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        notify(t("notifications_comments_copied"));
      })
      .catch((err) => {
        notify("Failed to copy: ", err);
      });
  };

  const getTransactionNo = (record, arr) => {
    if (record?.transactionNo) {
      return record.transactionNo;
    }

    if (record?.paramsJSON && typeof record.paramsJSON === "object") {
      if (record.paramsJSON.transactionNo) {
        return record.paramsJSON.transactionNo;
      }
    }

    if (arr && !Array.isArray(arr) && arr.transactionNo) {
      return arr.transactionNo;
    }

    if (Array.isArray(arr)) {
      const transactionEntry = arr.find(
        (item) =>
          item?.label === "transactionNo" ||
          item?.label === "TransactionNo" ||
          item?.label === "transactionno",
      );
      return transactionEntry?.value;
    }

    return null;
  };

  const viewOtherIncomeReceipt = (transactionNo) =>
    viewReceiptPdf({
      transactionNo,
      type: "otherIncome",
      t,
    }).catch(() => false);

  const viewExpenseVoucher = (transactionNo) =>
    viewExpenseVoucherPdf({
      transactionNo,
      t,
    }).catch(() => false);

  const addDetailedData = (memberId, memberUnitId) => {
    history.push({
      pathname: `member/updateMember/${memberId}`,
      state: {
        unitId: unit.unitId,
        currentUnitId: memberUnitId,
        unitName: unit.unitName,
        canModifyType: true,
        addNewRafiq: true,
        memberTypeId: 0,
        calledAs: "rafiq",
        isAssociated: false,
      },
    });
  };

  const printPdf = (
    id,
    notificationType,
    params,
    responsibilityData,
    comments,
  ) => {
    let type = 0;
    if (notificationType === "req_move_member") type = 1;
    else if (notificationType === "req_move_habib") type = 2;
    else if (notificationType.includes("assign")) type = 3;
    else if (notificationType.includes("mark_rafiq_ex")) type = 4;

    setPrintType((prevType) => {
      // Set the print type and ensure the next logic runs after the state updates
      if (prevType !== type) {
        return type;
      }
      return type; // Ensures re-render even if the value remains the same
    });

    setTimeout(() => {
      if (notificationType.includes("assign")) {
        if (unitTypeName === "Tanzeem") {
          setPrintData({
            ...params,
            AmeerHalqaFeedback: comments,
          });
        } else if (unitTypeName === "Halqa") {
          setPrintData({
            ...params,
            NazimAllaTabsaraOTasuraat: comments,
          });
        }

        setResponsibilityData(responsibilityData);
        window.print();
      } else if (notificationType.includes("mark_rafiq_ex")) {
        console.log(params);
        setPrintData(params);
        window.print();
      } else {
        ApiNotifications()
          .generateNotificationsPdfForm(id, notificationType)
          .then((res) => {
            setPrintData(res.data);
            window.print();
          })
          .catch((err) => console.log(`Error generating PDF: ${err}`));
      }
    }, 50); // Small delay to ensure state updates before running print logic
  };

  const cancelRequest = (notificationId) => {
    setNotificationId(notificationId);
    setCancelRequestModal(true);
  };

  const handleSelectChangeNotificationType = (event) => {
    //We save the whole object in the state SelectedType and only event will be used it contains the whole object
    setSelectedType(event);
  };

  const handleSelectRelevantUnit = (event) => {
    setSelectedRelevantUnit(event);
  };

  const handleSelectChangeApprovalStatus = (event) => {
    setSelectedApprovalStatus(event);
  };

  const handleSearchSerialNumber = (e) => {
    const { value } = e.target;
    setSearchSerialNumber(value);
  };

  const handleSelectChangeResponsibility = (event) => {
    setSelectedResponsibility(event);
  };

  const handleInputChangeStartDate = (value) => {
    if (DateValidater(value, endDate)) {
      setStartDate(value);
      setDateValidations(dateRangeValidation);
    } else {
      setDateValidations({
        ...dateValidations,
        startDate: (
          <GetLanguageString props="common_start_date_validation_message" />
        ),
      });
    }
  };

  const handleInputChangeEndDate = (value) => {
    if (DateValidater(startDate, value)) {
      setEndDate(value);
      setDateValidations(dateRangeValidation);
    } else {
      setDateValidations({
        ...dateValidations,
        endDate: (
          <GetLanguageString props="common_end_date_validation_message" />
        ),
      });
    }
  };

  // const handleOnEdit = (notificationId, unitId, memberId, check, code) => {
  //   setNotificationId(notificationId);
  //   if (code.includes("add_new_rafiq")) {
  //     setAddRafiqModal(true);
  //   } else if (code.includes("move_member")) {
  //     setMoveMemberUniId(unitId);
  //     setMoveMemberMemberId(memberId);
  //     setMoveMemberPermission(check);
  //     setMoveMemberModal(true);
  //   }
  // };

  const handleSearchName = (e) => {
    setSearchName(e.target.value);
  };

  const handleSearchButtonClick = () => {
    const record = {
      memberId: memberId,
      notificationTypeId: selectedType.value,
      approvalStatus: selectedApprovalStatus.value,
      relevantUnit: selectedRelevantUnit?.value,
      serialNumber: searchSerialNumber,
      startDate: startDate ?? Date.minDate,
      endDate: endDate,
      responsibilityId: selectedResponsibility.value,
      fullName: searchName,
    };

    setLoading(true);
    ApiNotifications()
      .getMemberRequests(record)
      .then((res) => {
        setPagination(res.data);
        setNotification(res.data.notificationList);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const excelDownload = () => {
    const record = {
      memberId: memberId,
      notificationTypeId: selectedType.value,
      approvalStatus: selectedApprovalStatus.value,
      relevantUnit: selectedRelevantUnit?.value,
      serialNumber: searchSerialNumber,
      startDate: startDate ?? Date.minDate,
      endDate: endDate,
      responsibilityId: selectedResponsibility.value,
      fullName: searchName,
      reportType: "memberRequest",
    };

    setExcelLoading(true);
    setExcelButtonDisable(true);
    ApiNotifications()
      .generateMemberNotificationsReport(record)
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        setExcelLoading(false);
        setExcelButtonDisable(false);
        saveAs(blob, "MyRequests.xlsx");
        setExcelLoading(false);
        setExcelButtonDisable(false);
      })
      .catch((err) => {
        console.log(err);
        swal({
          title: err.response.data,
          icon: "error",
          buttons: "OK",
        });
        setExcelLoading(false);
        setExcelButtonDisable(false);
      });
  };

  const toggleDropdownOpen = (index) => {
    let temp = [...notification];
    temp[index].dropDown = !notification[index].dropDown;
    setNotification(temp);
  };

  let recordIndex = pagination.pageSize * (pagination.activePage - 1) + 1;

  let pageInfo = `Displaying ${recordIndex}-${
    recordIndex + pagination.pageSize - 1 < pagination.totalItem
      ? recordIndex + pagination.pageSize - 1
      : pagination.totalItem
  } of ${pagination.totalItem}`;

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <ToastContainer
        autoClose={3000}
        bodyClassName={GetSelectedLanguage()}
        closeOnClick
        pauseOnHover={false}
        draggable
      />
      {viewFinanceNotificationModel ? (
        <TransactionTransferNotificationModal
          setViewFinanceNotificationModel={setViewFinanceNotificationModel}
          notificationId={notificationId}
        />
      ) : null}
      {viewInfaqAmanatForm ? (
        <FundsInfaqAmanatViewForm
          setViewInfaqAmanatForm={setViewInfaqAmanatForm}
          notificationId={notificationId}
        />
      ) : null}{" "}
      {viewSalaryTransferDetails ? (
        <SalaryTransferNotificationDetails
          notificationId={notificationId}
          setVisible={setViewSalaryTransferDetails}
        />
      ) : null}
      {viewOtherIncomeNotificationDetails ? (
        <FundsOtherIncomeNotificationDetails
          setViewOtherIncomeNotificationDetails={
            setViewOtherIncomeNotificationDetails
          }
          notificationId={notificationId}
        />
      ) : null}
      {viewUsraRemittanceApprovalForm ? (
        <UsraRemittanceApprovalForm
          notificationId={notificationId}
          setVisible={setViewUsraRemittanceApprovalForm}
          readOnly
        />
      ) : null}
      {modal ? (
        <SeeChanges
          setModal={setModal}
          values={values}
          notificationName={notificationName}
          documentNames={documents}
          notificationId={notificationId}
          serialNumber={serialNumber}
          isSerialNumberCancelled={isSerialNumberCancelled}
        />
      ) : null}
      {cancelRequestModal ? (
        <CancelRequestModal
          setupdateList={setupdateList}
          updateList={updateList}
          notificationId={notificationId}
          memberId={memberId}
          setCancelRequestModal={setCancelRequestModal}
        />
      ) : null}
      {/* {moveMemberModal && (
        <EditMoveMemberNotificationModal
          notificationId={notificationId}
          memberId={moveMemberMemberId}
          unitId={moveMemberUnitId}
          check={moveMemberPermission}
          setMoveMemberModal={setMoveMemberModal}
          setupdateList={setupdateList}
          updateList={updateList}
        />
      )} */}
      <PrintNotification
        printData={printData}
        calledFrom={"memberRequests"}
        printType={printType}
      />
      <PrintAssignResponsibilityNotification
        printData={printData}
        printType={printType}
        calledFrom={"memberRequests"}
        responsibilityData={responsibilityData}
      />
      <PrintMarkRafiqExNotification
        printData={printData}
        printType={printType}
        calledFrom={"memberRequests"}
      />
      {addRafiqModal && (
        <EditAddNewRafiqNotificationModal
          setAddRafiqModal={setAddRafiqModal}
          notificationId={notificationId}
          setupdateList={setupdateList}
          updateList={updateList}
        />
      )}
      <div className="ibox noprint">
        <div className="ibox-title">
          <h5>{<GetLanguageString props="common_search" />}</h5>
        </div>
        <div className="ibox-content">
          <Row>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {<GetLanguageString props="settings_notification_type" />}
                </Label>
                <Select
                  value={selectedType}
                  options={notificationTypes.map((notification) => ({
                    value: notification.id,
                    label: notification.name,
                  }))}
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={false}
                  onChange={handleSelectChangeNotificationType}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {<GetLanguageString props="notifications_approve_status" />}
                </Label>
                <Select
                  value={selectedApprovalStatus}
                  options={approvalStatuses.map((approval) => ({
                    value: approval.statusId,
                    label: <GetLanguageString props={approval.code} />,
                  }))}
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={false}
                  onChange={handleSelectChangeApprovalStatus}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {<GetLanguageString props="notifications_approved_by" />}
                </Label>
                <Select
                  value={selectedResponsibility}
                  options={responsibilities.map((responsibility) => ({
                    value: responsibility.value,
                    label: responsibility.label,
                  }))}
                  className="basic-single ur"
                  classNamePrefix="select"
                  isClearable={false}
                  onChange={handleSelectChangeResponsibility}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {<GetLanguageString props="notifications_requested_for" />}
                </Label>
                <Select
                  value={selectedRelevantUnit}
                  options={relevantUnitsList}
                  className="basic-single ur"
                  classNamePrefix="select"
                  isClearable={false}
                  onChange={handleSelectRelevantUnit}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <div className="ibox-content">
                <Label className="col-form-label">
                  <h4>
                    {<GetLanguageString props="notifications_creation_date" />}
                  </h4>
                </Label>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label className="col-form-label">
                        {<GetLanguageString props="member_report_from" />}
                      </Label>
                      <DatePicker
                        value={startDate}
                        showYearDropdown
                        placeholderText="dd/mm/yyyy"
                        className="form-control"
                        selected={startDate}
                        onChange={handleInputChangeStartDate}
                        dateFormat="dd/MM/yyyy"
                      />
                      {dateValidations.startDate && (
                        <h4 className="text-error">
                          {dateValidations.startDate}
                        </h4>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label className="col-form-label">
                        {<GetLanguageString props="member_report_to" />}
                      </Label>
                      <DatePicker
                        value={endDate}
                        showYearDropdown
                        placeholderText="dd/mm/yyyy"
                        className="form-control"
                        selected={endDate}
                        onChange={handleInputChangeEndDate}
                        dateFormat="dd/MM/yyyy"
                      />
                      {dateValidations.endDate && (
                        <h4 className="text-error">
                          {dateValidations.endDate}
                        </h4>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </Col>{" "}
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {
                    <GetLanguageString props="notifications_see_changes_serial_number" />
                  }
                </Label>
                <Input
                  type="text"
                  name="searchSerialNumber"
                  value={searchSerialNumber}
                  onChange={handleSearchSerialNumber}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {<GetLanguageString props="common_search_by_name" />}
                </Label>
                <Input
                  className={isUrdu(searchName) ? "ur" : ""}
                  type="text"
                  name="searchName"
                  value={searchName}
                  onChange={handleSearchName}
                />
              </FormGroup>
            </Col>
          </Row>
          <br></br>
          <br></br>
          <Row>
            <Col className="text-center">
              <FormGroup>
                <Button
                  color="primary"
                  className="m-l-sm"
                  type="submit"
                  onClick={handleSearchButtonClick}
                >
                  {<GetLanguageString props="common_search" />}
                </Button>
              </FormGroup>
            </Col>
          </Row>
        </div>
      </div>
      <div className="ibox noprint">
        <div className="ibox-title">
          <h5>{<GetLanguageString props="notifications_requests" />}</h5>
          {notification.length !== 0 ? (
            <Button
              color="default"
              size="sm"
              disabled={excelButtonDisable}
              onClick={excelDownload}
              className={GetCustomStyles().btn_style}
            >
              <RiFileExcel2Line
                size={15}
                color="#009440"
                style={{ marginRight: 3, marginBottom: 1 }}
              />
              {excelLoading ? (
                <Spinner
                  style={{ marginRight: 10, marginLeft: 10 }}
                  size="sm"
                  color="black"
                />
              ) : (
                <GetLanguageString props="member_report_export_excel" />
              )}
            </Button>
          ) : null}
        </div>
        <div className="ibox-content">
          {!loading ? (
            notification.length !== 0 ? (
              <Table responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>
                      {
                        <GetLanguageString props="settings_notification_type_name" />
                      }
                    </th>
                    <th>{<GetLanguageString props="common_name" />}</th>
                    <th
                      className="cursor-pointer"
                      onClick={() => handleSorting("creationDate")}
                    >
                      {
                        <GetLanguageString props="notifications_creation_date" />
                      }
                      <span className={GetFooTableCustomStyles().span_style}>
                        {record.creationDate === "neutral" ? (
                          <>
                            <i
                              className={
                                GetFooTableCustomStyles().up_down_style
                              }
                            />
                            <i
                              className={
                                GetFooTableCustomStyles().down_up_style
                              }
                            />
                          </>
                        ) : record.creationDate === "ascending" ? (
                          <i className={GetFooTableCustomStyles().up_style} />
                        ) : (
                          <i className={GetFooTableCustomStyles().down_style} />
                        )}
                      </span>
                    </th>
                    <th>
                      {<GetLanguageString props="notifications_approve_date" />}
                    </th>
                    <th>
                      {<GetLanguageString props="notifications_approved_by" />}
                    </th>
                    <th>
                      {
                        <GetLanguageString props="notifications_requested_for" />
                      }
                    </th>
                    <th>
                      {
                        <GetLanguageString props="notifications_see_changes_serial_number" />
                      }
                    </th>
                    <th>
                      {
                        <GetLanguageString props="notifications_approve_status" />
                      }
                    </th>
                    <th>
                      {
                        <GetLanguageString props="member_member_detail_course_comments" />
                      }
                    </th>
                    <th className="text-center">
                      {<GetLanguageString props="common_action" />}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {notification
                    .sort(function (a, b) {
                      if (a.startDate < b.startDate) return 1;
                      if (a.startDate > b.startDate) return -1;
                      return 0;
                    })
                    .map((record, index) => {
                      let arr = [];
                      let type = record.code;
                      if (record.code.includes("move_member")) {
                        arr = record.seeChanges;
                      } else if (record.code.includes("move_habib")) {
                        arr = record.seeChangesHabib;
                      } else if (record.code.includes("assign")) {
                        arr = record.seeChangesAssignResponsibility;
                      } else if (
                        record.code.includes("mark_rafiq_ex") ||
                        record.code.includes("member_type_change_request")
                      ) {
                        arr = record.seeChangesCommon;
                      } else {
                        if (Array.isArray(record.paramsJSON)) {
                          arr = record.paramsJSON;
                        } else {
                          arr = Object.entries(record.paramsJSON).map(
                            ([key, value]) => {
                              return {
                                label: key,
                                value: value,
                              };
                            },
                          );
                        }
                      }
                      let isTextUrdu = isUrdu(record.comments);
                      let maxLength = isTextUrdu ? 40 : 30;

                      return (
                        <>
                          <tr key={index}>
                            <td>{index + recordIndex}</td>
                            <td>
                              {" "}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                {record.notificationTypeName}
                                {record.paramsJSON.IsRegisteredAsHabib ? (
                                  <Badge
                                    color="primary"
                                    pill // This makes the badge round
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <span className={"ur"}>حبیب</span>
                                  </Badge>
                                ) : null}
                              </div>
                            </td>
                            <td
                              className={
                                isUrdu(
                                  record.code.includes("new_rafiq")
                                    ? record.paramsJSON.FullName
                                    : arr.fullName,
                                )
                                  ? "ur"
                                  : ""
                              }
                            >
                              {record.code.includes("new_rafiq")
                                ? record.paramsJSON.FullName
                                : arr.fullName}
                            </td>
                            <td>
                              {moment(
                                convertUTCToLocalTime(record.createdAt),
                              ).format("DD/MM/yyyy")}
                            </td>
                            <td>
                              {record.completedAt
                                ? moment(
                                    convertUTCToLocalTime(record.completedAt),
                                  ).format("DD/MM/yyyy")
                                : "-"}
                            </td>
                            <td className="ur">
                              {record.responsibilityName?.length !== 0 ? (
                                <Label
                                  className="label label-primary ur"
                                  size="m"
                                >
                                  <h5>{record.responsibilityName}</h5>
                                </Label>
                              ) : (
                                "-"
                              )}
                            </td>{" "}
                            <td className="ur">
                              {record.relatedUnits?.length !== 0
                                ? record.relatedUnits?.map((item, index) => {
                                    return (
                                      <>
                                        <Label
                                          className="label label-info ur m-1"
                                          size="sm"
                                        >
                                          <h5>{item.label}</h5>
                                        </Label>
                                      </>
                                    );
                                  })
                                : "-"}
                            </td>
                            <td>
                              {record.rafiqSerialNumbers === "0" ||
                              record.rafiqSerialNumbers === "" ||
                              record.rafiqSerialNumbers === null ? (
                                "-"
                              ) : (
                                <>
                                  {record.rafiqSerialNumbers}{" "}
                                  {record.isSerialNumberCancelled && (
                                    <span
                                      className={
                                        GetSelectedLanguage() === "ur"
                                          ? "ur"
                                          : ""
                                      }
                                    >
                                      ({t("notifications_cancel")})
                                    </span>
                                  )}
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                color:
                                  record.approvalStatus === 1
                                    ? "Green"
                                    : record.approvalStatus === 2
                                      ? "Red"
                                      : record.approvalStatus === 4
                                        ? "Red"
                                        : record.approvalStatus === 0 ||
                                          record.approvalStatus == null
                                          ? "Orange"
                                          : record.approvalStatus === 3
                                            ? "Gold"
                                            : record.approvalStatus === 5
                                              ? "Green"
                                              : record.approvalStatus === 6
                                                ? "Orange"
                                                : null,
                                fontWeight: "bold",
                              }}
                            >
                              {" "}
                              {record.approvalStatus === 1 ? (
                                <GetLanguageString props="notifications_approve" />
                              ) : record.approvalStatus === 2 ? (
                                <GetLanguageString props="notifications_reject" />
                              ) : record.approvalStatus === 4 ? (
                                <GetLanguageString props="notifications_cancel" />
                              ) : record.approvalStatus === 0 ||
                                record.approvalStatus == null ? (
                                <GetLanguageString props="notifications_pending" />
                              ) : record.approvalStatus === 3 ? (
                                <GetLanguageString props="notifications_on_hold" />
                              ) : record.approvalStatus === 5 ? (
                                <GetLanguageString props="notifications_read" />
                              ) : record.approvalStatus === 6 ? (
                                <GetLanguageString props="notifications_unread" />
                              ) : null}
                            </td>
                            <td>
                              {record?.comments ? (
                                <Row>
                                  <Col md="10">
                                    <span
                                      className={isTextUrdu ? "ur" : "en"}
                                      id={`tooltip-${index}`}
                                      onMouseEnter={() => toggleTooltip(index)}
                                      onMouseLeave={() => toggleTooltip(index)}
                                    >
                                      {isTextUrdu ? (
                                        <h4>
                                          {record.comments?.length > maxLength
                                            ? `${record.comments?.slice(
                                                0,
                                                maxLength,
                                              )}...`
                                            : record.comments}
                                        </h4>
                                      ) : record.comments?.length >
                                        maxLength ? (
                                        `${record.comments?.slice(
                                          0,
                                          maxLength,
                                        )}...`
                                      ) : (
                                        record.comments
                                      )}
                                      {record.comments?.length > maxLength ? (
                                        <Tooltip
                                          isOpen={tooltipOpen === index}
                                          target={`tooltip-${index}`}
                                          toggle={() => toggleTooltip(index)}
                                        >
                                          <h3
                                            className={isTextUrdu ? "ur" : "en"}
                                          >
                                            {record.comments}
                                          </h3>
                                        </Tooltip>
                                      ) : null}
                                    </span>
                                  </Col>
                                  <Col md="2">
                                    <TbCopy
                                      id={`tooltipCopy-${index}`}
                                      style={{
                                        marginTop: 8,
                                        outline: "none",
                                        cursor: "pointer",
                                      }}
                                      color="#5a9b75 "
                                      size={20}
                                      onClick={() =>
                                        copyToClipboard(record.comments)
                                      }
                                    />
                                    <Tooltip
                                      isOpen={tooltipOpenCopy === index}
                                      target={`tooltipCopy-${index}`}
                                      toggle={() => toggleTooltipCopy(index)}
                                    >
                                      <h5
                                        className={
                                          GetSelectedLanguage() === "ur"
                                            ? "ur"
                                            : "en"
                                        }
                                      >
                                        {"Copy Comment"}
                                      </h5>
                                    </Tooltip>
                                  </Col>
                                </Row>
                              ) : null}
                            </td>
                            <td className="text-center">
                              <Dropdown
                                isOpen={record.dropDown}
                                toggle={() => {
                                  toggleDropdownOpen(index);
                                }}
                                style={{ position: "static" }}
                              >
                                <DropdownToggle
                                  className="btn btn-default"
                                  tag="span"
                                  aria-expanded={record.dropDown}
                                >
                                  {<GetLanguageString props="common_action" />}
                                  <b className="caret m-l-xs" />
                                </DropdownToggle>
                                <DropdownMenu
                                  style={{
                                    minWidth: "0rem",
                                    fontSize: "13px",
                                  }}
                                >
                                  <div>
                                    {(() => {
                                      const options = [];

                                      if (
                                        record.rafiqSerialNumbers !== "0" &&
                                        record.rafiqSerialNumbers !== "" &&
                                        record.code.includes("add_new_rafiq")
                                      ) {
                                        options.push(
                                          <DropdownItem
                                            key="add_detailed_data"
                                            onClick={() =>
                                              addDetailedData(
                                                record.memberId,
                                                record.unitId,
                                              )
                                            }
                                          >
                                            <GetLanguageString props="member_Add_detailed_data" />
                                          </DropdownItem>,
                                        );
                                      }

                                      if (
                                        !record.isCancelled &&
                                        (record.approvalStatus === 0 ||
                                          record.approvalStatus === 3)
                                      ) {
                                        options.push(
                                          <DropdownItem
                                            key="cancel_request"
                                            onClick={() =>
                                              cancelRequest(record.id)
                                            }
                                          >
                                            <GetLanguageString props="notification_cancel_request" />
                                          </DropdownItem>,
                                        );
                                      }
                                      if (
                                        record.code === "req_add_new_rafiq" &&
                                        record.approvalStatus === 1
                                      ) {
                                        options.push(
                                          <DropdownItem
                                            key="member_add_rafiq_request_download_welcome_letter"
                                            onClick={() =>
                                              downloadWelcomeLetter(
                                                record.memberId,
                                                record.code.includes(
                                                  "new_rafiq",
                                                )
                                                  ? record.paramsJSON.FullName
                                                  : arr.fullName,
                                              )
                                            }
                                          >
                                            <GetLanguageString props="member_add_rafiq_request_download_welcome_letter" />
                                          </DropdownItem>,
                                        );
                                      }

                                      // if (
                                      //   record.code === "req_move_member" &&
                                      //   (record.approvalStatus === 0 ||
                                      //     record.approvalStatus === 3)
                                      // ) {
                                      //   options.push(
                                      //     <DropdownItem
                                      //       key="edit_request"
                                      //       onClick={() => {
                                      //         handleOnEdit(
                                      //           record.id,
                                      //           record.paramsJSON?.NextUnitId,
                                      //           record.paramsJSON?.MemberId,
                                      //           record.permissionCheckMoveMember,
                                      //           record.code
                                      //         );
                                      //       }}
                                      //     >
                                      //       <GetLanguageString props="common_edit" />
                                      //     </DropdownItem>
                                      //   );
                                      // }
                                      if (
                                        record.code.includes("mark_rafiq_ex") &&
                                        record.isFileAttached
                                      ) {
                                        options.push(
                                          <DropdownItem
                                            key="member_mark_as_ex_request_view_file"
                                            onClick={() =>
                                              openFile(
                                                record.id,
                                                record.rafiqSerialNumbers,
                                              )
                                            }
                                          >
                                            <GetLanguageString props="member_mark_as_ex_request_view_file" />
                                          </DropdownItem>,
                                        );
                                        options.push(
                                          <DropdownItem
                                            key="member_mark_as_ex_request_download_file"
                                            onClick={() =>
                                              downloadFile(
                                                record.id,
                                                record.rafiqSerialNumbers,
                                              )
                                            }
                                          >
                                            <GetLanguageString props="member_mark_as_ex_request_download_file" />
                                          </DropdownItem>,
                                        );
                                      }

                                      if (
                                        record.code.includes("monthly_report")
                                      ) {
                                        options.push(
                                          <DropdownItem
                                            key="notification_monthly_report_download_excel"
                                            onClick={() =>
                                              downloadNotificationExcel(
                                                arr[0].value,
                                                record.code,
                                              )
                                            }
                                          >
                                            <GetLanguageString props="notification_monthly_report_download_excel" />
                                          </DropdownItem>,
                                        );
                                        options.push(
                                          <DropdownItem
                                            key="notification_monthly_report_download_pdf"
                                            onClick={() =>
                                              downloadMonthlyReportPdf(
                                                arr[0].value,
                                                record.code,
                                              )
                                            }
                                          >
                                            <GetLanguageString props="notification_monthly_report_download_pdf" />
                                          </DropdownItem>,
                                        );
                                      }
                                      if (
                                        (record.code === "req_move_member" ||
                                          record.code === "req_move_habib") &&
                                        record.approvalStatus === 1
                                      ) {
                                        options.push(
                                          <DropdownItem
                                            key="print_request"
                                            onClick={() =>
                                              printPdf(
                                                record.id,
                                                record.code,
                                                record.paramsJSON.param,
                                                arr,
                                                record.comments,
                                              )
                                            }
                                          >
                                            <GetLanguageString props="common_print" />
                                          </DropdownItem>,
                                        );
                                      }

                                      const isOtherIncomeReceiptNotification =
                                      (record.code === "req_loan_from_markaz"
                                       ||
                                        record.code=== "req_reimbursment_tarbiati_course"
                                         ||
                                        record.code=== "req_help_from_muqami_tanzeem") &&
                                      record.approvalStatus === 1;


                                      const receiptTransactionNo = getTransactionNo(
                                        record,
                                        arr,
                                      );

                                      if (
                                        isOtherIncomeReceiptNotification &&
                                        receiptTransactionNo &&
                                        Number(receiptTransactionNo) !== 0
                                      ) {
                                        options.push(
                                          <DropdownItem
                                            key="view_other_income_receipt"
                                            onClick={() =>
                                              viewOtherIncomeReceipt(
                                                receiptTransactionNo,
                                              )
                                            }
                                          >
                                            {<GetLanguageString props="common_view_receipt" />}
                                          </DropdownItem>,
                                        );
                                      }

                                      const isExpenseReceiptNotification =
                                        (record.code === "req_expense_from_amanat" ||
                                         record.code === "req_expense_from_cash_in_hand" ||
                                         record.code === "expense_from_amanat" ||
                                         record.code === "expense_from_cash_in_hand" ||
                                         record.code === "req_expense_maktaba_payment" ||
                                         record.code === "req_expense_nida_payment") &&
                                        record.approvalStatus === 1;

                                      if (
                                        isExpenseReceiptNotification &&
                                        receiptTransactionNo &&
                                        Number(receiptTransactionNo) !== 0
                                      ) {
                                        options.push(
                                          <DropdownItem
                                            key="view_expense_voucher"
                                            onClick={() =>
                                              viewExpenseVoucher(
                                                receiptTransactionNo,
                                              )
                                            }
                                          >
                                            {<GetLanguageString props="common_view_voucher" />}
                                          </DropdownItem>,
                                        );
                                      }

                                      if (
                                        record.code.includes("assign") ||
                                        record.code.includes("mark_rafiq_ex") ||
                                        record.code.includes(
                                          "member_type_change_request",
                                        )
                                      ) {
                                        !record.code.includes(
                                          "member_type_change_request",
                                        )
                                          ? options.push(
                                              <DropdownItem
                                                key="print_request"
                                                onClick={() => {
                                                  printPdf(
                                                    record.id,
                                                    record.code,
                                                    record.code.includes(
                                                      "assign",
                                                    )
                                                      ? record.paramsJSON.param
                                                      : record.paramsJSON,
                                                    arr,
                                                    record.comments,
                                                    record.approvalStatus === 0,
                                                  );
                                                }}
                                              >
                                                <GetLanguageString props="common_print" />
                                              </DropdownItem>,
                                            )
                                          : options.push(
                                              <DropdownItem
                                                key="member_member_type_request_download_form"
                                                onClick={() => {
                                                  downloadNotificationPdf(
                                                    arr.memberId,
                                                    arr.fullName,
                                                    record.code,
                                                    record.id,
                                                  );
                                                }}
                                              >
                                                <GetLanguageString props="member_member_type_request_download_form" />
                                              </DropdownItem>,
                                            );
                                      }
                                      if (
                                        !record.code.includes("assign") &&
                                        !record.code.includes(
                                          "mark_rafiq_ex",
                                        ) &&
                                        !record.code.includes(
                                          "monthly_report",
                                        ) &&
                                        !record.code.includes(
                                          "member_type_change_request",
                                        )
                                      ) {
                                        options.push(
                                          <DropdownItem
                                            key="member_details"
                                            onClick={() => {
                                              if (
                                                record.code ===
                                                  "req_amanat_to_cash_in_hand" ||
                                                record.code ===
                                                  "req_edit_amanat_to_cash_in_hand" ||
                                                record.code ===
                                                  "req_cash_to_amanat_transfer" ||
                                                record.code ===
                                                  "req_edit_cash_to_amanat_transfer"
                                              ) {
                                                setViewFinanceNotificationModel(
                                                  true,
                                                );
                                              } else if (
                                                record.code ===
                                                  "req_infaq_to_amanat_account" ||
                                                record.code ===
                                                  "req_edit_infaq_to_amanat_account"
                                              ) {
                                                setViewInfaqAmanatForm(true);
                                              } else if (
                                                record.code ===
                                                "req_usra_infaq_remittance"
                                              ) {
                                                setViewUsraRemittanceApprovalForm(
                                                  true,
                                                );
                                              } else if (
                                                record.code ===
                                                "req_salary_from_amanat"
                                              ) {
                                                setViewSalaryTransferDetails(true);
                                              } else if (
                                                record.code.includes(
                                                  "loan_from_markaz",
                                                ) ||
                                                record.code.includes(
                                                  "reimbursment_tarbiati_course",
                                                ) ||
                                                record.code.includes(
                                                  "help_from_muqami_tanzeem",
                                                ) ||
                                                record.code ===
                                                  "req_expense_from_amanat" ||
                                                record.code ===
                                                  "req_edit_expense_from_amanat" ||
                                                record.code ===
                                                  "req_maktaba_payment_to_markaz" ||
                                                record.code ===
                                                  "req_nida_payment_to_markaz" ||
                                                record.code ===
                                                  "req_expense_from_cash_in_hand" ||
                                                record.code ===
                                                  "req_edit_expense_from_cash_in_hand" ||
                                                record.code ===
                                                  "req_asset_donation" ||
                                                record.code ===
                                                  "req_halqa_share" ||
                                                record.code ===
                                                  "req_edit_halqa_share" ||
                                                record.code ===
                                                  "req_delete_halqa_share" ||
                                                record.code ===
                                                  "req_markaz_share" ||
                                                record.code ===
                                                  "req_edit_markaz_share" ||
                                                record.code ===
                                                  "req_delete_markaz_share"
                                              ) {
                                                setViewOtherIncomeNotificationDetails(
                                                  true,
                                                );
                                              } else {
                                                setModal(true);
                                                setValues(arr);
                                                setNotificationName(type);
                                                setDocuments(record.documents);
                                                setSerialNumber(
                                                  record.rafiqSerialNumbers,
                                                );
                                                setIsSerialNumberCancelled(
                                                  record.isSerialNumberCancelled,
                                                );
                                              }
                                              setNotificationId(record.id);
                                            }}
                                          >
                                            <GetLanguageString props="member_detail_btn" />
                                          </DropdownItem>,
                                        );
                                      }

                                      return options.length > 0 ? (
                                        options
                                      ) : (
                                        <div className="text-center p-2">
                                          {GetSelectedLanguage() !== "ur"
                                            ? "No Option Available"
                                            : "کوئی آپشن موجود نہیں ہے"}
                                        </div>
                                      );
                                    })()}
                                  </div>
                                </DropdownMenu>
                              </Dropdown>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                </tbody>
                <tr>
                  <td colSpan="10">{pageInfo}</td>
                  <td colSpan="11">
                    <ul className={GetCustomStyles().page_style}>
                      <Pagination
                        activePage={pagination.activePage}
                        itemsCountPerPage={pagination.pageSize}
                        totalItemsCount={pagination.totalItem}
                        pageRangeDisplayed={pagination.pageRange}
                        onChange={handlePageChange}
                      />
                    </ul>
                  </td>
                </tr>
              </Table>
            ) : (
              <NoResult />
            )
          ) : (
            LoadingSpinner()
          )}
        </div>
      </div>
    </div>
  );
};
export default withRouter(MemberRequests);
